import { useToast } from 'components/ToastContainer';

const useHandlePreferencesErrorToast = () => {
  const toast = useToast();
  // Helper function to handle preference loading errors
  const displayPreferenceErrorToast = () => {
    toast.error('Unable to display saved values.', {
      supportButton: true,
      content:
        'An error prevented us from displaying your previously entered values. This will not affect your ability to enter data or save new records.'
    });
  };

  return {
    displayPreferenceErrorToast
  };
};

export default useHandlePreferencesErrorToast;
